import get from 'lodash/get';

import { DEFAULT_LANG } from 'server/constants';

export default function getZoneDefaultLang(state: any) {
  return get(state, 'page.data.zone.default_lang', DEFAULT_LANG);
}
